<template>
  <VcWidget
    class="footer-links"
    size="xs"
    :border="false"
    :shadow="false"
    :collapsible="isMobile"
    :collapsed="isMobile"
  >
    <template #header-container="{ collapsible, collapsed }">
      <span class="footer-links__header">
        <span class="footer-links__title text-base">{{ $t("shared.layout.footer.social-media.title") }}</span>

        <VcIcon
          v-if="collapsible"
          :size="16"
          :class="['footer-links__arrow', { 'footer-links__arrow--rotate': collapsed }]"
          name="chevron-up"
        />
      </span>
    </template>

    <template #default-container>
      <div class="social-links">
        <a href="https://buff.ly/P4faHGn" target="_blank" rel="noopener noreferrer nofollow" class="social-links_link"
          ><VcIcon name="social-facebook" size="xl"
        /></a>

        <a href="https://buff.ly/klozE85" target="_blank" rel="noopener noreferrer nofollow" class="social-links_link"
          ><VcIcon name="social-linkedin" size="xl"
        /></a>

        <a
          href="https://twitter.com/bossardgroup"
          target="_blank"
          rel="noopener noreferrer nofollow"
          class="social-links_link"
          ><VcIcon name="social-x" size="xl"
        /></a>

        <a
          href="https://www.youtube.com/user/BossardGroup"
          target="_blank"
          rel="noopener noreferrer nofollow"
          class="social-links_link"
          ><VcIcon name="social-youtube" size="xl"
        /></a>
      </div>
    </template>
  </VcWidget>
</template>

<script setup lang="ts">
import { useBreakpoints } from "@vueuse/core";
import { BREAKPOINTS } from "@/core/constants";

const breakpoints = useBreakpoints(BREAKPOINTS);
const isMobile = breakpoints.smaller("sm");
</script>

<style type="scss">
.social-links {
  @apply flex flex-row gap-1 my-2;

  &_link {
    @apply inline-block w-10 h-10 hover:opacity-40;

    span {
      @apply max-w-full max-h-full;
    }
  }
}
</style>
